export default __webpack_public_path__ + "static/media/mid-b-12-thumb.78d003c8.jpg";